import React, {useEffect} from "react";
import Routes from "./Routes";
//custom script hook
import useScript from './hooks/useScript'

import "./assets/css/bootstrap.min.css";
import "./assets/css/icofont.min.css";
import "./assets/css/classy-nav.min.css";
import "./assets/css/responsive.css";
import "./assets/css/style.css";

const App = () => {
    useScript('assets/js/popper.min.js');
    useScript('assets/js/bootstrap.min.js');
    useScript('assets/js/classy-nav.min.js');
    useScript('assets/js/tilt.jquery.min.js');
    useScript('assets/js/jquery.counterup.min.js');
    useScript('assets/js/waypoints.min.js');
    // useScript('assets/js/custom-script.js');
    return <Routes/>;
};

export default App;
